<template>

    <button
    @click.prevent="validateForm()"
    :disabled="sendingForm"
    class="btn-action btn-action--center assistance__login-btn-submit"
    >

      <i
      v-show="sendingForm"
      class="fas fa-circle-notch fa-spin">
      </i>

      <span>{{labelSendBtn}}</span>

    </button>

</template>

<script>

export default {

  props: ['sendingForm'],

  methods: {

    validateForm(){
      bus.$emit('assistance/validateNewCustomerForm');
    }

  },

  computed: {

    labelSendBtn(){
      return this.sendingForm ? 'Aguarde' : 'Enviar';
    }

  }

};

</script>
